import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { NO_COMPARISON, variation } from "../../utils/analyticsDeltas";
import { capabilitiesOf, shownOnly } from "../../utils/analyticsCapabilities";
import { formatCount, formatPercent } from "../charts/format";
import KpiStrip from "./KpiStrip";
import { openRateKpi, previousAndPerDayText, startedWithSuggestionKpi } from "./kpis";

// Os numeros principais da visao geral (spec do redesign, R4.1), quatro, ou tres num chat sem operadores,
// na faixa de numeros: o valor, a variacao contra o periodo anterior, a mini tendencia dos dois periodos e
// uma linha de contexto. Num periodo de chat embutido a taxa de abertura nao tem sentido e da o lugar as
// mensagens de clientes (R8). A taxa de abertura e as conversas iniciadas por uma sugestao vem do
// `kpis.js`, como nos separadores.
const KpiPanel = ({ summary, previousComplete }) => {
  const { translate, language } = useLanguage();
  const change = (args) => (previousComplete ? variation(args, language) : NO_COMPARISON);
  const { headline, series, endings, chat } = summary;
  const m = series.metrics;
  const count = (value) => formatCount(value, language);
  const percent = (value) => (value === null ? translate("analyticsNotAvailable") : formatPercent(value, language));
  const pairOf = (key) => headline[key];
  const shared = { summary, previousComplete, translate, language };

  const second = chat.docked
    ? {
        key: "customer_messages",
        label: translate("analyticsCustomerMessages"),
        value: count(pairOf("customer_messages").value),
        change: change({ kind: "count", ...pairOf("customer_messages") }),
        spark: [m.customer_messages.current, m.customer_messages.previous],
        context: translate("analyticsKpiPrevious", { previous: count(pairOf("customer_messages").previous) }),
      }
    : openRateKpi(shared);

  const withoutOperator = (conversations, withOperator) => conversations.map((value, index) => (value ? 100 - (100 * withOperator[index]) / value : null));

  const kpis = [
    {
      key: "conversations",
      label: translate("analyticsConversations"),
      value: count(pairOf("conversations").value),
      change: change({ kind: "count", ...pairOf("conversations") }),
      spark: [m.conversations.current, m.conversations.previous],
      context: previousAndPerDayText({ previous: pairOf("conversations").previous, total: pairOf("conversations").value, series, translate, language }),
    },
    second,
    {
      key: "without_operator",
      needs: "operators",
      label: translate("analyticsWithoutOperator"),
      value: percent(pairOf("conversations_without_operator_pct").value),
      change: change({ kind: "percent", ...pairOf("conversations_without_operator_pct") }),
      spark: [withoutOperator(m.conversations.current, m.conversations_with_operator.current), withoutOperator(m.conversations.previous, m.conversations_with_operator.previous)],
      context: translate(endings.conversations_with_operator === 1 ? "analyticsKpiWithOperatorContextOne" : "analyticsKpiWithOperatorContext", { count: count(endings.conversations_with_operator) }),
      info: translate("analyticsWithoutOperatorNote"),
    },
    startedWithSuggestionKpi(shared),
  ];

  return <KpiStrip label={translate("analyticsHeadline")} kpis={shownOnly(kpis, capabilitiesOf(summary))} />;
};

export default KpiPanel;
